import { render, staticRenderFns } from "./NormalButton.vue?vue&type=template&id=5b32b1b7"
import script from "./NormalButton.vue?vue&type=script&lang=js"
export * from "./NormalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports